// extracted by mini-css-extract-plugin
export const searchBarSubmit = "NavSearch-module--search-bar-submit--1g6KQ";
export const searchBarSubmitIcon = "NavSearch-module--search-bar-submit-icon--3UwwF";
export const searchBarPrependIcon = "NavSearch-module--search-bar-prepend-icon--1koxb";
export const navSearch = "NavSearch-module--nav-search--RpxUj";
export const navSearchIcon = "NavSearch-module--nav-search-icon--3xlGj";
export const searchBarContainer = "NavSearch-module--search-bar-container--3tTD5";
export const searchInput = "NavSearch-module--search-input--1MqfF";
export const searchBarSubmitLabel = "NavSearch-module--search-bar-submit-label--2Tr_u";
export const openSearchButton = "NavSearch-module--open-search-button--13T3h";
export const searchBarExpanded = "NavSearch-module--search-bar-expanded--Pi9NF";